import PropTypes from 'prop-types';

export const AttachmentsPropTypes = {
  allowMultiple: PropTypes.bool,
  attachmentIds: PropTypes.array,
  canNotDownload: PropTypes.bool,
  disabled: PropTypes.bool,
  entity: PropTypes.string,
  labelFileProcessingComplete: PropTypes.string,
  labelTapToUndo: PropTypes.string,
  onChange: PropTypes.func,
  onDeleteFile: PropTypes.func,
  style: PropTypes.string,
};

export const AttachmentsDefaultProps = {
  labelFileProcessingComplete: 'Upload complete',
  labelTapToUndo: 'tap to undo'
};
